import React from "react";
import ReactDOM from "react-dom";
// import { client } from "./Constants/apolloClient";
// import { ApolloProvider } from '@apollo/client';

// it need
const reactRender = (element, component, props, mode) => {
    props = props == null || typeof props === "string" ? JSON.parse(props ?? "{}") : props;
    const { App: Report } = require("./App");
    const app = {
        Report: Report
    };

    let comp = app[component];
    if (comp) {
        comp = React.createElement(comp, props);
    }

    if (mode == null)
        ReactDOM.render(
            <>
                {/* <ApolloProvider client={client}>{comp}</ApolloProvider> */}
                {comp}
            </>,
            element
        );
    else
        ReactDOM.hydrate(
            <>
                {/* <ApolloProvider client={client}>{comp}</ApolloProvider> */}
                {comp}
            </>,
            element
        );
};

const watch = inElement => {
    const build = mutations => {
        mutations.forEach(function (mutation) {
            if (!mutation) return;

            const { type, addedNodes } = mutation;

            if (type === "childList") {
                (addedNodes ?? []).forEach(node => {
                    if (
                        node.getAttribute &&
                        node.getAttribute("react-app") === "mw" &&
                        node.getAttribute("react-component") &&
                        node.getAttribute("react-props") &&
                        !node.children.length
                    ) {
                        const component = node.getAttribute("react-component");
                        const props = node.getAttribute("react-props");

                        reactRender(node, component, props);
                    }
                });
            }
        });
    };

    const observer = new MutationObserver(build);

    observer.observe(inElement, {
        // attributes: true,
        // characterData: true,
        childList: true
        // subtree: true,
        // attributeOldValue: true,
        // characterDataOldValue: true
    });

    let mutations = observer.takeRecords();
    build(mutations);
};

export { reactRender, watch };
